<template>
<div class="container tc">
  <template v-if="!show">
    <PageTitle></PageTitle>
    <div class="play-box tc">
      <div @click="startPlay" class="inner">
        <div class="img-box">
          <img src="../assets/img/icon_start.svg" alt="">
        </div>
        <span class="txt">START</span>
      </div>
      <p>Find out which presidential candidate you sound like for the upcoming election.</p>
    </div>
  </template>
  <div v-if="show && !workStatus" class="sample-box tc">
    <div class="content with-bg tl">
      <h3>Click the record button then read the following text:</h3>
      <p>We close up the greatest economy in the world in order to fight this horrible disease that came from China. It’s a worldwide pandemic. It’s all over the world.</p>
      <p>220,000 Americans dead. If you hear nothing else I say tonight, hear this.</p>
    </div>

    <div v-show="!recording" class="play-box record-box tc">
      <div class="inner">
        <div @click="recordStart" class="img-box">
          <img src="../assets/img/icon_record_start.png" width="95" alt="">
        </div>
      </div>
      <p>Click to start recording.</p>
    </div>

    <div v-show="recording" class="play-box record-box tc">
      <div class="inner">
        <div @click="recordSTop" class="img-box stop-box">
          <span></span>
        </div>
        <span class="time">{{ formatTime(time) }}</span>
      </div>
      <p>Click to stop recording.</p>
    </div>
  </div>

  <div v-if="workStatus == 'process'" class="process-box tc">
    <div class="content with-bg">
      <img width="50" class="loading-img" src="../assets/img/loading.png" alt="">
      <h3>Hold on while we crunch some numbers…</h3>
      <a @click="recordReset" href="javascript:;">I want to record a new piece of sound</a>
    </div>
  </div>

  <div v-if="workStatus == 'success' && res && res.result.length" class="process-box process-succ tc">
    <div class="content with-bg">
      <h4>You sound {{ Number(res.result[1]).toFixed(0) }}% like:</h4>
      <h3 v-if="res.result[0] == 'trump'">{{ names[res.result[0]] }}</h3>
      <h3 v-else>{{ names[res.result[0]] }}</h3>

      <div class="share-box">
        <p>Learned something new about your voice? Share your results with your friends and family!</p>
        <div class="share-icons">
          <!--<img @click="shareFb()" id="fb-btn" src="../assets/img/fb.svg" alt="">-->
          <img @click="shareTw()" src="../assets/img/tw.svg" alt="">
          <!--<img src="../assets/img/is.svg" alt="">-->
        </div>
      </div>
      <a href="/"> Back to Home</a>
    </div>
  </div>

  <div v-if="modalShow" class="modal">
    <div class="modal-content">
      <img class="modal-close" src="../assets/img/icon_modal_close.png" alt="">
      <p>Sorry, we could not detect a microphone on your device.</p>
      <a @click="modalShow = false" href="javascript:;" class="btn">OK</a>
    </div>
  </div>
</div>
</template>
<script>
import PageTitle from '@/components/Title'
import Recorder from 'recorder-core'
import 'recorder-core/src/engine/wav'
import 'recorder-core/src/engine/mp3-engine'
import 'recorder-core/src/engine/beta-amr'
import 'recorder-core/src/engine/beta-amr-engine'

export default {
  name: 'Index',
  components: { PageTitle },
  data () {
    return {
      show: false,
      recording: false,
      workStatus: '',
      time: '',
      rec: Recorder({
        type: 'wav',
        sampleRate: 16000,
        bitRate: 16,
        onProcess: (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) => {
          this.time = bufferDuration
          console.log(this.time)
        }
      }),
      modalShow: false,
      shareTitle: 'I just found out that I sound like Donald {%name%} ! Who do you sound like? Click on this link to find out: apresidentsvoice.com',
      names: {
        'trump': 'Donald Trump',
        'biden': 'Joe Biden'
      }
    }
  },
  mounted () {
    this.initFbSdk()
  },
  methods: {
    startPlay () {
      this.show = true
	    let that = this
      this.show = true
      let recOpen = function () { // 一般在显示出录音按钮或相关的录音界面时进行此方法调用，后面用户点击开始录音时就能畅通无阻了
        that.rec.open(function () {
          // console.log('已打开录音，可以点击开始了')
          // rec.start() 此处可以立即开始录音，但不建议这样编写，因为open是一个延迟漫长的操作，通过两次用户操作来分别调用open和start是推荐的最佳流程
        }, function (msg, isUserNotAllow) { // 用户拒绝未授权或不支持
          // clearTimeout(t);
          // console.log((isUserNotAllow ? 'UserNotAllow，' : '') + '无法录音:' + msg, 1)
          that.modalShow = true
        })
      }

      recOpen()
    },
    recordStart () {
	  this.recording = true
      this.recStart()
    },
    recordSTop () {
      this.recording = false
      this.workStatus = 'process'
      this.recStop()
    },
    recordReset () {
      this.recording = false
      this.workStatus = ''
    },
    recStart () {
      // 打开了录音后才能进行start、stop调用
      this.rec.start()
    },
    recStop () {
      let that = this
      this.rec.stop((blob, duration) => {
        // eslint-disable-next-line no-undef
        console.log(blob, (window.URL || webkitURL).createObjectURL(blob), '时长:' + duration + 'ms')
        var form = new FormData();
        form.append('file', blob, 'recorder.wav')
        that.$axios({
          method: 'post',
          url: 'https://backend.apresidentsvoice.com/process', // 'http://127.0.0.1:5000/process',
          data: form,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (res) {
          console.log(res)
          if (res.data.message == 'OK') {
            that.res = res.data
            that.workStatus = 'success'
          } else {
            alert('Please try again')
          }
          that.rec.close()
          that.rec = null
        })
        //
        // /** * 【立即播放例子】 ***/
        // var audio = document.createElement('audio')
        // audio.controls = true
        // document.body.appendChild(audio)
        // // 简单利用URL生成播放地址，注意不用了时需要revokeObjectURL，否则霸占内存
        // // eslint-disable-next-line no-undef
        // audio.src = (window.URL || webkitURL).createObjectURL(blob)
        // audio.play()
      }, function (msg) {
        console.log('录音失败:' + msg)
        that.rec.close() // 可以通过stop方法的第3个参数来自动调用close
        that.rec = null
        alert('Sorry, we could not detect a microphone on your device.')
      })
    },
    formatTime (mss) {
      // let days = parseInt(mss / (1000 * 60 * 60 * 24))
      // let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      // let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
      // let seconds = (mss % (1000 * 60)) / 1000

      let minutes = Math.floor(mss / 60000)
      let seconds = (mss % (1000 * 60)) / 1000
      return minutes + ":" + seconds
    },
    shareTw () {
      let shareInfo = {
        title: this.shareTitle,//分享标题
        url: 'http://apresidentsvoice.com',
      }
      let uri = 'http://twitter.com/share?url='+encodeURIComponent(shareInfo.url) +'&text='+ encodeURIComponent(shareInfo.title.replace('{%name%}', this.names[this.res.result[0]]));
      window.open(uri, '_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=550,top=100,left=350');
    },
    initFbSdk() {
      window.fbAsyncInit = function() {
        FB.init({
          appId: "1028589500622437",
          autoLogAppEvents: true,
          xfbml: true,
          version: "v3.0"
        });
      };
    },
    shareFb () {
      FB.ui(
        {
          method: "share",
          href: ''
          // href: "http://test-affiliateback.dvdfab.cn" + res.result.url
        },
        // callback
        function(response) {
          if (response && !response.error_message) {
            console.log("Posting completed.");
          } else {
            console.log("cancel share");
          }
        }
      );
    }
  }
}
</script>

<style scoped>
  @import "../assets/css/index.css";
</style>



// WEBPACK FOOTER //
// src/view/Index.vue